import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const MARKETING_PATHS = ['/features', '/register-organization', '/guides', '/privacy'];

function Footer() {
  const location = useLocation();
  const isMarketingPage = MARKETING_PATHS.some(p => location.pathname.startsWith(p));

  if (isMarketingPage) {
    return (
      <footer className="site-footer">
        <div className="container">
          <div className="footer-columns">
            {/* Left: Logo + tagline */}
            <div className="footer-col footer-col-brand">
              <img src="/assets/logoCA24.png" width="150" height="25" alt="Church Aware" className="footer-logo" />
              <p className="footer-tagline">The modern church directory platform</p>
            </div>

            {/* Middle: Quick Links */}
            <div className="footer-col">
              <h4 className="footer-col-title">Quick Links</h4>
              <ul className="footer-nav">
                <li><Link to="/features">Features</Link></li>
                <li><Link to="/guides">Guides</Link></li>
                <li><Link to="/register-organization">Register Your Church</Link></li>
              </ul>
            </div>

            {/* Right: Contact */}
            <div className="footer-col">
              <h4 className="footer-col-title">Contact</h4>
              <ul className="footer-nav">
                <li><a href="mailto:contact@churchaware.com">contact@churchaware.com</a></li>
                <li>
                  <a href="https://apps.apple.com/us/app/church-aware/id1422942877?ls=1" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-apple"></i> App Store
                  </a>
                </li>
                <li>
                  <a href="https://play.google.com/store/apps/details?id=com.churchaware.churchaware" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-google-play"></i> Google Play
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="footer-bottom">
            <p className="footer-copyright">&copy; 2026 Church Aware Inc.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/privacy">Terms of Service</Link>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="site-footer site-footer-simple">
      <div className="container">
        <div className="footer-content">
          <p className="footer-copyright">&copy; 2026 Church Aware Inc.</p>
          <div className="footer-links">
            <a href="/privacy">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
